export default function getDoorOpeningLogo(doorOpeningName) {
  try {
    return require(`assets/images/door-opening/${doorOpeningName.toLowerCase()}.png`);
  } catch (error) {
    console.log("Can't find logo image for Door opening integration: ", doorOpeningName);
    return require(`assets/images/door-opening/tesa.png`);
  }
}
